/**
 * Voice Rooms Hooks
 * TanStack Query hooks for voice room operations
 */

import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import { toast } from 'sonner';
import * as voiceRoomsService from '@/services/voice-rooms.service';

export const useVoiceRooms = () => {
  return useQuery({
    queryKey: ['voice', 'rooms'],
    queryFn: () => voiceRoomsService.listVoiceRooms(),
    staleTime: 5 * 60 * 1000,
  });
};

export const useCreateVoiceRoom = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (data: { name: string; description?: string; maxParticipants?: number }) =>
      voiceRoomsService.createVoiceRoom(data),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['voice', 'rooms'] });
      toast.success('Стаята е създадена');
    },
    onError: () => {
      toast.error('Грешка при създаване на стая');
    },
  });
};

export const useUpdateVoiceRoom = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: ({ roomId, data }: { roomId: string; data: Parameters<typeof voiceRoomsService.updateVoiceRoom>[1] }) =>
      voiceRoomsService.updateVoiceRoom(roomId, data),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['voice', 'rooms'] });
      toast.success('Стаята е актуализирана');
    },
    onError: () => {
      toast.error('Грешка при актуализиране на стая');
    },
  });
};

export const useDeleteVoiceRoom = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (roomId: string) => voiceRoomsService.deleteVoiceRoom(roomId),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['voice', 'rooms'] });
      toast.success('Стаята е изтрита');
    },
    onError: () => {
      toast.error('Грешка при изтриване на стая');
    },
  });
};
